<template lang="pug">
  v-dialog(v-model="show" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable max-width="700" persistent )
    v-card.pa-0(flat)
      v-card-title {{ $t('orderPage.orderControlDialogTitle') }}: {{date}}
      v-card-text(v-if="!isMultipleGroupMenu")
        v-list(v-for="(subGroupItem, idx) in topMenuGroup.subGroupList" :key="idx" )
          v-subheader(v-if="isSubGroupItemTitle(subGroupItem)" ) {{ subGroupItem.title }}

          v-list-item( v-for="(optionItem, idx) in subGroupItem.optionList" :key="idx"
            v-if="optionItem.offer && optionItem.offer.foodItem && foodList.includes(optionItem.id)")
            v-list-item-icon.align-self-center
              v-icon(small color="success") fas fa-check-circle
            v-list-item-content.subtitle-1(readonly) {{ optionItem.offer.foodItem.name }}
            v-list-item-icon.slot-code.align-self-center.align-center
              span.title.pr-4 {{ optionItem.code }}
              v-list-item-content.title.text-end(readonly v-if="isMultiplePortion") {{ getAmount(optionItem.offer.id) }}x
        v-divider(v-if="isBoarderNote")
        v-textarea.mt-4(:label=" $t('orderPage.boarderNoteLabel')" v-model="description" outlined height="150px" v-if="isBoarderNote && $vuetify.breakpoint.mdAndUp" counter :rules="boarderNoteRules")
        v-textarea.mt-4(:label=" $t('orderPage.boarderNoteLabel')" v-model="description" outlined height="150px" v-if="isBoarderNote && $vuetify.breakpoint.smAndDown" counter :rules="boarderNoteRules")
      v-card-text(v-else)
        v-list.pa-0(v-for="(subGroupItem, idx) in getFilteredSubGroupList" :key="idx" dense)
          v-subheader(v-if="getTitle(idx)" ) {{ subGroupItem.title }}

          v-list-item( v-for="(optionItem, idx) in subGroupItem.optionList" :key="idx"
            v-if="optionItem.offer && optionItem.offer.foodItem && foodList.includes(optionItem.id)")
            v-list-item-icon.align-self-center
              v-icon(small color="success") fas fa-check-circle
            v-list-item-content.subtitle-1(readonly) {{ optionItem.offer.foodItem.name }}

            v-list-item-icon.slot-code.align-self-center.align-center
              span.title.pr-4 {{ optionItem.code }}
              v-list-item-content.title(readonly v-if="isMultiplePortion") {{ optionItem.offer.amount }}x
        v-divider(v-if="isBoarderNote")
        v-textarea.mt-4(:label=" $t('orderPage.boarderNoteLabel')" v-model="description" outlined height="150px" v-if="isBoarderNote && $vuetify.breakpoint.mdAndUp" counter :rules="boarderNoteRules")
        v-textarea.mt-4(:label=" $t('orderPage.boarderNoteLabel')" v-model="description" outlined height="150px" v-if="isBoarderNote && $vuetify.breakpoint.smAndDown" counter :rules="boarderNoteRules")

      v-divider
      v-card-actions
        v-spacer
        v-btn.pr-2(text @click="onCloseButtonClick" :disabled="fetchInProgress") {{ $t('buttons.closeButtonLabel') }}
        v-btn.pr-2(color="primary" @click="onConfirmButtonClick" :loading="fetchInProgress" :disabled="isConfirmButtonDisabled")  {{ $t('orderPage.confirmButtonLabel') }}

</template>

<script lang="ts">
import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import MenuGroupItemOrder from "@/model/dailymenu/MenuGroupItemOrder";
import DailyMenuOptionOrder from "@/model/dailymenu/DailyMenuOptionOrder";
import i18n from "@/i18n";

@Component({
  components: {
  }
})
export default class ControlOrderDialog extends Vue {
  @Prop({type: Boolean, default: false}) readonly show!: boolean
  @Prop({type: Map, required: true}) currentSelection!: Map<MenuGroupItemOrder, DailyMenuOptionOrder | DailyMenuOptionOrder[]>
  @Prop({type: Object, required: true}) topMenuGroup!: MenuGroupItemOrder
  @Prop({type: String, required: true}) date!: any
  @Prop({type: Boolean, default: false}) readonly isMultiplePortion!: boolean
  @Prop({type: Boolean, default: false}) readonly isMultipleGroupMenu!: boolean
  @Prop({type: Boolean, default: false}) readonly isBoarderNote!: boolean
  @Prop({type: Array, required: false}) reservationItem!: any[] | undefined
  @Prop({type: Array, required: true}) menuGroupList!: any[]


  private fetchInProgress = false
  private foodList: string[] = []
  private selectionPayload: Map<MenuGroupItemOrder, DailyMenuOptionOrder | DailyMenuOptionOrder[]> = new Map()
  private description: string | null = null
  private boarderNoteRules: Array<(v: string | null) => string | boolean> = [
    (v: string | null) => v === null || (v !== null && v.length < 580) || i18n.t('orderPage.maxLengthBoarderNote').toString()
  ]

  get isConfirmButtonDisabled () {
    if(this.description && this.description.length > 580) {
      return true
    }
  }

  get getFilteredSubGroupList (): any[] {
    let list: any[] = []
    this.menuGroupList.forEach((item: any) => {
      item.subGroupList.forEach((i: any) => {
        list.push(i)
      })
    })

    return list
  }

  getTitle (idx: number): any {
    let data: boolean[] = []
    this.getFilteredSubGroupList[idx].optionList.forEach((subGroupItem: DailyMenuOptionOrder) => {
      if(this.foodList.includes(subGroupItem.id)){
        data.push(true)
      } else {
        data.push(false)
      }
    })
    return data.includes(true)
  }

  onCloseButtonClick(): void {
    this.$emit('close')
  }

  onConfirmButtonClick(): void {
    this.fetchInProgress = true
    this.$emit('confirm', this.selectionPayload,this.description)
  }

  isSubGroupItemTitle (subGroupItem: MenuGroupItemOrder ): boolean {
    let conditions: boolean[] = []
    subGroupItem.optionList.forEach((item: DailyMenuOptionOrder) => {
      conditions.push(this.foodList.includes(item.id))
    })
    return conditions.some(v=>v)
  }

  getAmount (id: string): number {
    let amount = 0
    this.currentSelection.forEach((value: any, key: any) => {
      if(value.offer.id === id) {
        amount = value.offer.amount
      }
    })
    return amount
  }

  mounted(): void {
    this.selectionPayload = this.currentSelection

    if(!this.isMultipleGroupMenu) {
      this.currentSelection.forEach((value: any, key: any) => {
        const foundItem: MenuGroupItemOrder | undefined = this.topMenuGroup.subGroupList.find((item: MenuGroupItemOrder) => item.id === key.id)
        if (foundItem) {
          if (value instanceof Array) {
            value.forEach((item: DailyMenuOptionOrder) => {
              this.foodList.push(item.id)
            })
          } else {
            this.foodList.push(value.id)
          }
        }
      })
    }else{
      this.currentSelection.forEach((value: any, key: any) => {
        if (value instanceof Array) {
          value.forEach((item: DailyMenuOptionOrder) => {
            this.foodList.push(item.id)
          })
        } else {
          this.foodList.push(value.id)
        }
      })
    }
    if(this.reservationItem){
      this.reservationItem?.forEach((item: any) => {
        this.description = item.boarderNote ? item.boarderNote : null

      })
    } else {
      this.description = null
    }
    }

}
</script>

<style lang="stylus" scoped>
</style>
